module.exports = __webpack_public_path__ + "img/category-new-released.b59dc0fc.png";